import { IKline } from '@/request/kline/kline.response.interface';
import { KlinePeriodTime } from './config';

export const periodSeconds = {
  '1m': 60,
  '5m': 5 * 60,
  '1h': 60 * 60,
  '4h': 4 * 60 * 60,
  '1d': 24 * 60 * 60,
};
const loadCount = {
  '1m': 400,
  '5m': 400,
  '1h': 400,
  '4h': 400,
  '1d': 400,
};
export const calculateTimeRange = (currentTimestamp: number, period: KlinePeriodTime) => {
  const timeOffset = periodSeconds[period] * loadCount[period];

  return {
    from: currentTimestamp - timeOffset,
    to: currentTimestamp - periodSeconds[period],
  };
};

export const updateKLineWithWsData = (lastKLine: any, wsData: IKline, period: KlinePeriodTime) => {
  const timeInterval = periodSeconds[period];

  const currentKLineEndTime = lastKLine?.time + timeInterval;

  if (wsData.timestamp >= Number(lastKLine.time) && wsData.timestamp < currentKLineEndTime) {
    lastKLine.close = Number(wsData.close);
    lastKLine.high = Math.max(lastKLine.high, Number(wsData.high));
    lastKLine.low = Math.min(lastKLine.low, Number(wsData.low));
  } else if (wsData.timestamp >= currentKLineEndTime) {
    lastKLine = {
      time: Math.floor(lastKLine.time) + timeInterval,
      open: Number(lastKLine.close),
      close: Number(wsData.close),
      high: Number(wsData.high),
      low: Number(wsData.low),
      volume: wsData.volume,
    };
  }

  return lastKLine;
};
